import { HTTP, BACKOFFICE_V2 } from "@/services/HTTPService";
// rewrite replace to store api (error with import api to actions)
import store from '../store'

export default {
    async getSegmentTags(segmentId = null) {
        const { data } = await BACKOFFICE_V2.get(
            `/booking_distribution_tags/?segment=${segmentId}`
        );

        return data
    },
    async getMimksTags(mimks = [], segmentId = null,  withSaveInStore = false) {
        mimks = [...new Set(mimks)].filter(mimkId => !!mimkId)
        let data = null;
        if (withSaveInStore) {
            for (let i = 0; i < Math.ceil(mimks.length / 50); i++) {
                let mimksArray = mimks.slice(i * 50, i * 50 + 50)
                const { data: dataForStore } = await HTTP.get(
                    `/distribution_tags/mimk?segment_id=${segmentId}&tcm_ids=${mimksArray.join(',')}`
                );

                store.commit('tags/setMimksTags', dataForStore)
            }
        } else {
            const { data: tagsData } = await HTTP.get(
                `/distribution_tags/mimk?segment_id=${segmentId}&tcm_ids=${mimks.join(',')}`
            );

            data = tagsData
        }

        return data
    },
    async getBookingsTags(bookings = [], withSaveInStore = false) {
        console.log('getBookingsTags')
        bookings = [...new Set(bookings)].filter(bookingId => !!bookingId)
        let data = null;
        if (withSaveInStore) {
            for (let i = 0; i < Math.ceil(bookings.length / 50); i++) {
                let bookingArray = bookings.slice(i * 50, i * 50 + 50)
                const { data: dataForStore } = await HTTP.get(
                    `/distribution_tags/booking?booking_ids=${bookingArray.join(',')}`
                );

                store.commit('tags/setBookingsTags', dataForStore)
            }
        } else {
            const { data: tagsData } = await HTTP.get(
                `/distribution_tags/booking?booking_ids=${bookings.join(',')}`
            );

            data = tagsData
        }

        return data
    },
    setMimkTags(tcm_id = null, segment_id = null, distribution_tag_ids = []) {
        return HTTP.post(`/distribution_tags/mimk`, {
            segment_id,
            tcm_id,
            distribution_tag_ids,
        })
    },
    setBookingTags(booking_id = null, segment_id = null, distribution_tag_ids = []) {
        return HTTP.post(`/distribution_tags/booking`, {
            segment_id,
            booking_id,
            distribution_tag_ids,
        })
    },
    deleteMimkTags(tcm_id = null, segment_id = null) {
        return HTTP.delete(`/distribution_tags/mimk?segment_id=${segment_id}&tcm_id=${tcm_id}`)
    },
    deleteBookingTags(booking_id = null, segment_id = null) {
        return HTTP.delete(`/distribution_tags/booking?segment_id=${segment_id}&tcm_id=${booking_id}`)
    },
}
